export default __webpack_public_path__ + "static/media/10.277e7004.PNG";